import React, { Component, Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import tableS from '../../asset/image/table_S.jpg'
import Sea from '../../asset/image/sea.jpg'
import nnn from '../../asset/image/nnn.jpg'
import Kadinco from '../../asset/image/kadinco.jpg'
import ModestWear from '../../asset/image/modestwear.jpg'
import Aiza from '../../asset/image/aiza.png'



import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"

export class clientReview extends Component {
  render() {
     var settings = {
   
  autoplay: true,
  autoplaySpeed: 6000,
  pauseOnHover: true,
  dots: true,
  //vertical:true,
  //verticalSwapping:true,
  infinite: true,
  speed: 800,
  arrows: true,
  slidesToShow: 1,            // Show 3 slides at once (center + 2 sides)
  centerMode: true,           // Centers the active slide
  centerPadding: '100px',      // Space showing the sides
  focusOnSelect: true,        // Click side image to make it active
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
  ],




  };
    



    return (
      <Fragment>
        <Container fluid={true} className='siderBack text-center'>
              <h1 className='revieweTitle p-3'>Client Reviews</h1>
            <div className='reviewbottom'></div>
              <Slider {...settings}>
              
                <div>
            <Row className='text-center justify-content-center'>
                <Col lg={6} md={6} sm={12}>
                <img className='circleImage' src={Aiza}/>
                 <h1 className='reviewh1Tag'>Aiza Modest</h1>
        
                 <p className='reviewpTag'>@Halima_syed you did it again. Thank you for organizing this successful bazaar!! We can't wait to see you all in another event soon. And if you couldn't make it, anyone can come to our store for last minute Eid shopping or Chaand Raat shopping.</p>
           
                </Col>
            </Row>
            </div>
                <div>
            <Row className='text-center justify-content-center'>
                <Col lg={6} md={6} sm={12}>
                <img className='circleImage' src={ModestWear}/>
                 <h1 className='reviewh1Tag'>ModestWear</h1>
        
                 <p className='reviewpTag'>Alhamdulillah it was the great turn out for two days. I would like to thanks community people who supported our dream and special thanks to @halima_syed for her hard work for organizing successful event.</p>
           
                </Col>
            </Row>
            </div>
             <div>
            <Row className='text-center justify-content-center'>
                <Col lg={6} md={6} sm={12}>
                <img className='circleImage' src={Kadinco}/>
                 <h1 className='reviewh1Tag'>Kadinco</h1>
        
                 <p className='reviewpTag'>Thank you @halima_syed and Jamila. Because of your efforts we raised $1200! Alhamdulillah @hcicanada</p>
           
                </Col>
            </Row>
            </div>
             <div>
            <Row className='text-center justify-content-center'>
                <Col lg={6} md={6} sm={12}>
                <img className='circleImage' src={Sea}/>
                 <h1 className='reviewh1Tag'>Modish Range</h1>
        
                 <p className='reviewpTag'>Huge thanks to everyone who stopped by and shopped at my both!. So nice meeting you all and big thanks to the organizers for such a great event!</p>
           
                </Col>
            </Row>
            </div>
            </Slider>
        </Container>
      </Fragment>
    )
  }

}

export default clientReview
